import React from 'react';
import { motion } from 'framer-motion';
interface AnimatedSectionProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}
export const AnimatedSection = ({
  children,
  delay = 0.2,
  className = ''
}: AnimatedSectionProps) => {
  return <motion.div initial={{
    opacity: 0,
    y: 50
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.8,
    delay,
    ease: 'easeOut'
  }} className={className} data-id="element-46">
      {children}
    </motion.div>;
};